import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { GenericService } from 'src/app/services/generic.service';

@Component({
  selector: 'app-maintenance-schedule',
  templateUrl: './maintenance-schedule.component.html',
  styleUrls: ['./maintenance-schedule.component.css']
})
export class MaintenanceScheduleComponent implements OnInit {


  singleObjectInfoData: any = []
  maintenanceScheduleId = ""
  page: number = 1;
  count: number = 0;
  tableSize: number = 10;
  first: number = 0;
  tableSizes: any = [3, 6, 9, 12];
  cid:any
  objectInfoList: any = []
  maintenanceScheduleList: any = []
  isLoading: any = false
  objectInfoId: any

  addForm: any | FormGroup

  maintenanceType = [
    {
      key: "Preventive Maintenance (PM) Schedule",
      value: "PreventiveMaintenanceSchedule"
    },
    {
      key: "Corrective Maintenance Schedule",
      value: "CorrectiveMaintenanceSchedule"
    },
    {
      key: "Predictive Maintenance Schedule",
      value: "PredictiveMaintenanceSchedule"
    },
    {
      key: "Condition-Based Maintenance (CBM)",
      value: "ConditionBasedMaintenance"
    }
  ]

  frequencyType = [
    {
      key: "Daily: Operational checks (temperature, pressure, noise, etc.)",
      value: "Daily"
    },
    {
      key: "Weekly: Lubrication, filter checks, fluid levels",
      value: "Weekly"
    },
    {
      key: "Monthly: In-depth inspections, cleaning, software updates",
      value: "Monthly"
    },
    {
      key: "Quarterly: Component replacements (belts, seals), diagnostics",
      value: "Quarterly"
    },
    {
      key: "Annually: Major overhauls, part replacements, certifications",
      value: "Annually"
    }
  ]

  todayDate: any
  searchFilter: any = "";
  recordId: any = "";
  recordName: any = "";
  formSubmit: any = false

  constructor(private fb: FormBuilder,private toastr: ToastrService,private generic_service: GenericService) { }

  ngOnInit(): void {
    this.cid = sessionStorage.getItem('cid')
    this.getAllObjectInfo()
    this.getAllMaintenanceSchedule()
    const now = new Date();

    const today = new Date();
    const tomorrow = new Date(today);
    tomorrow.setDate(today.getDate() + 1);

    // Format to YYYY-MM-DD
    this.todayDate = tomorrow.toISOString().split('T')[0];

    this.addForm = this.fb.group({
      "description": ['',[Validators.required]],
      "maintenanceType": ['',[Validators.required]],
      "frequency": ['',[Validators.required]],
      "nextDueDate":['',[Validators.required]],
      "assetId": ['',[Validators.required]],
      "assetName":['']
    })
  }


  onTableDataChange(event: any) {
    console.log(event)
    this.page = event.page+1;
  }

  getMaintenanceType(type: any){
    for(let list of this.maintenanceType){
      if(list.value == type){
        return list.key
      }
    }
    return ""
  }

  getMaintenanceScheduleById(maintenanceScheduleId: any){
    this.generic_service.getMaintenanceScheduleById(maintenanceScheduleId).subscribe(
      (response:any)=>{
        console.log(response);
        this.singleObjectInfoData = []
        this.singleObjectInfoData.push(response.response)
      },
      (error:any)=>{
        console.log(error)
      }
    )
  }

  getAllObjectInfo(){
    this.generic_service.getAllObjectInfo().subscribe(
      (response:any)=>{
        console.log(response);
        this.objectInfoList = response.response
      },
      (error:any)=>{
        console.log(error)
      }
    )
  }

  getAllMaintenanceSchedule(){
    this.generic_service.getAllMaintenanceSchedule().subscribe(
      (response:any)=>{
        console.log(response);
        this.maintenanceScheduleList = response.response
        this.count = response.response.length
      },
      (error:any)=>{
        console.log(error)
      }
    )
  }


  selectDelete(id:any,list: any){
    this.maintenanceScheduleId = id;

    this.recordId = list.scheduleId
    this.recordName = list.assetName
  }
  
  clearData(){
    this.recordId = "";
    this.recordName = "";
  }

  refreshAll(){
    this.page = 1
    this.first = 0
    this.searchFilter = ""
    this.getAllMaintenanceSchedule()
  }

  getAllMaintenanceSchedulesByWildSearch(){
    console.log(this.searchFilter)
    if(this.searchFilter == "" || this.searchFilter == null){
      return
    }
    this.generic_service.getAllMaintenanceSchedulesByWildSearch(this.searchFilter).subscribe(
      (res: any) => {
        if(res.response == null || res.response.length == 0 || res.response == undefined){
        this.maintenanceScheduleList = []
        this.count = 0
          return

        }
        this.maintenanceScheduleList = res.response
        this.count = res.response.length
      },
      (err: any) => {
        console.log(err);
      }
    );
  }


  deleteMaintenanceSchedule(){
    this.generic_service.deleteMaintenanceSchedule(this.maintenanceScheduleId).subscribe(
      (response:any)=>{
        console.log(response);
        document.getElementById("closeModalDelete")?.click()
        this.getAllMaintenanceSchedule()
        this.toastr.success(response.message)
        this.clearData()
      },
      (error:any)=>{
        console.log(error)
        this.toastr.error(error.errors[0].description)
      }
    )
  }


  remove(){
    document.getElementById("closeModalButton")?.click()
    this.addForm.reset()
  }

  addMaintenanceSchedule(){
    for(let list of this.objectInfoList){
      if(list.objectInfoId == this.addForm.get('assetId').value){
        this.addForm.patchValue({
          assetName: list.givenName
        })
      }
    }

    if(this.formSubmit){
      return
    }

    if(!this.addForm.valid){
      this.toastr.error("Please fill in all required fields");
      this.formSubmit = false;
      return
    }

    this.formSubmit = true;

    let body = {
      "version": 0,
      "isActive": true,
      "description": this.addForm.get('description').value,
      "assetId": this.addForm.get('assetId').value,
      "assetName": this.addForm.get('assetName').value,
      "maintenanceType": this.addForm.get('maintenanceType').value,
      "frequency": this.addForm.get('frequency').value,
      "nextDueDate": this.addForm.get('nextDueDate').value,
      "lastPerformed": "",
      "cid": Number(this.cid)
    }

    console.log(body)
    this.generic_service.addMaintenanceSchedule(body).subscribe(
      (response: any)=>{
        console.log(response)
        this.toastr.success(response.message);
        this.getAllMaintenanceSchedule()
        document.getElementById("closeModalButton1")?.click()
        this.formSubmit = false;
      },
      (error: any)=>{
        this.toastr.error(error.error.errors[0].description);
        this.formSubmit = false;
        console.log(error)
      }
    )

  }

}